import React from "react";

export function AppRouter({
  page,
  navigate,
  authMode,
  setAuthMode,
  userData,
  firebaseUser,
  effectiveUserId,
  generatorState,
  updateGeneratorState,
  onAuthAction,
  onGoogleSignIn,
  onLogout,
  onCheckout,
  onManageSubscription,
  onCreditUpdate,
  supportAwaitingCount,
  shareId,
  guestSupportToken,
  components,
}) {
  const {
    LandingPage,
    AuthPage,
    GeneratorPage,
    PricingPage,
    AccountPage,
    GalleryPage,
    ShareLandingPage,
    SupportPage,
    GuestSupportPage,
    AdminPage,
  } = components;

  switch (page) {
    case "landing":
      return <LandingPage onNavigate={navigate} />;
    case "auth":
      return (
        <AuthPage
          onAuthAction={onAuthAction}
          onGoogleSignIn={onGoogleSignIn}
          mode={authMode}
          setMode={setAuthMode}
          onNavigate={navigate}
        />
      );
    case "app":
      return (
        <GeneratorPage
          user={userData}
          onLogout={onLogout}
          onNavigate={navigate}
          onCreditUpdate={onCreditUpdate}
          generatorState={generatorState}
          updateGeneratorState={updateGeneratorState}
          firebaseUser={firebaseUser}
          effectiveUserId={effectiveUserId}
          supportAwaitingCount={supportAwaitingCount}
        />
      );
    case "pricing":
      return (
        <PricingPage
          user={userData}
          onCheckout={onCheckout}
          onNavigate={navigate}
          onLogout={onLogout}
          firebaseUser={firebaseUser}
          supportAwaitingCount={supportAwaitingCount}
        />
      );
    case "account":
      return (
        <AccountPage
          user={userData}
          onNavigate={navigate}
          onManageSubscription={onManageSubscription}
          onLogout={onLogout}
          firebaseUser={firebaseUser}
          effectiveUserId={effectiveUserId}
          supportAwaitingCount={supportAwaitingCount}
        />
      );
    case "gallery":
      return (
        <GalleryPage
          user={userData}
          onNavigate={navigate}
          onLogout={onLogout}
          firebaseUser={firebaseUser}
          effectiveUserId={effectiveUserId}
          generatorState={generatorState}
          updateGeneratorState={updateGeneratorState}
          onCreditUpdate={onCreditUpdate}
          supportAwaitingCount={supportAwaitingCount}
        />
      );
    case "share":
      return <ShareLandingPage onNavigate={navigate} shareId={shareId} />;
    case "support":
      return (
        <SupportPage
          user={userData}
          onNavigate={navigate}
          onLogout={onLogout}
          firebaseUser={firebaseUser}
          effectiveUserId={effectiveUserId}
          supportAwaitingCount={supportAwaitingCount}
        />
      );
    case "guest-support":
      return (
        <GuestSupportPage token={guestSupportToken} onNavigate={navigate} />
      );
    case "admin":
      return <AdminPage onNavigate={navigate} />;
    default:
      return <LandingPage onNavigate={navigate} />;
  }
}
